function replaceRegisteredMarks(root = document.getElementById("MainContent")) {
  if (!root) return;

  const walker = document.createTreeWalker(
    root,
    NodeFilter.SHOW_TEXT,
    null
  );

  const nodes = [];

  while (walker.nextNode()) {
    nodes.push(walker.currentNode);
  }

  nodes.forEach(node => {
    if (!node.nodeValue.includes("®")) return;

    // Skip if already converted
    if (node.parentNode.closest('sup')) return;

    const span = document.createElement("span");
    span.innerHTML = node.nodeValue.replace(/®/g, '<sup>®</sup>');

    node.parentNode.replaceChild(span, node);
  });
}

// Initial run
document.addEventListener("DOMContentLoaded", () => {
  replaceRegisteredMarks();

  // ✅ Watch for dynamically injected content (related products etc.)
  const observer = new MutationObserver(() => {
    replaceRegisteredMarks();
  });

  observer.observe(document.getElementById("MainContent"), {
    childList: true,
    subtree: true
  });
});

// Shopify section reloads
document.addEventListener("shopify:section:load", replaceRegisteredMarks);
